import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types'
import '../QueuePage.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';
import Lang from '../../../components/language/services/Lang';
import { SortTypes, FilterTypes } from '../enums/SortAndFilterTypes';
import { QueueTableTypes } from '../enums/QueueTableTypes';
import QueueFilterCheckbox from './QueueFilterCheckbox'
import ClearAllFilters from './ClearAllFilters';
import ReassignButtonDropdown from './reassign/ReassignButtonDropdown';
import classNames from 'classnames'

const QueueTableSortHeader = ({ sort, tableType, queue, toggleFilter, filterState, handleClearTableFilters, showReassignOption, reassignTicketIds, isAssociateQueue, officeId, associateFirstName, associateId, pageSelections }) => {
    const [sortKey, setSortKey] = useState('Default');
    const resultCount = queue && queue.totalCount;
    const [showCounter, setShowCounter] = useState(false);

    useEffect(() => {
        if (tableType === QueueTableTypes.UNASSIGNED) {
            setSortKey("ReadyToBeAssigned")
        } 
    }, [tableType])

    useEffect(() => {
        if (reassignTicketIds?.length > 0) {
            setShowCounter(true)
        } else {
            setShowCounter(false)
        }
    }, [reassignTicketIds])

    return (
        <Fragment>
            <div className="columns level">
                <div className='column is-12'>
                    <div className='queue-table-result-header'>
                        <HrbTranslate
                            text={`QueuePage.SortTitles.${sortKey}.${resultCount > 1 ? 'multiple' : 'single'}`}
                            params={{ SortType: Lang.getCurrentValue(`QueuePage.SortTypes.${sort}`), count: resultCount }}
                        />
                        {showCounter && showReassignOption &&
                            <HrbTranslate text='QueuePage.SortTitles.TicketsCounter' params={{ selectedCount: reassignTicketIds?.length }} />}
                    </div>
                    {tableType === QueueTableTypes.DEFAULT &&
                    <div className='queue-filter-checkbox'>
                        <QueueFilterCheckbox name='QueuePage.SortTitles.ShowClosedTickets' isChecked={filterState.closedTicketsOnly} onClick={() => toggleFilter(FilterTypes.CLOSED_TICKETS_ONLY)} />
                        <QueueFilterCheckbox name='QueuePage.SortTitles.UnreadMsgsOnly' isChecked={filterState.hasUnreadMessage} onClick={() => toggleFilter(FilterTypes.HAS_UNREAD_MESSAGES)} />
                        <div className={classNames('queue-table-filter-clear', { 'queue-table-filter-clear-reassign': showReassignOption })}> 
                            <ClearAllFilters onClick={handleClearTableFilters} textKey='QueuePage.Labels.ClearFilters'/>
                        </div>
                            {showReassignOption &&
                                <ReassignButtonDropdown reassignTicketIds={reassignTicketIds} isAssociateQueue={isAssociateQueue} officeId={officeId} associateFirstName={associateFirstName} associateId={associateId} pageSelections={pageSelections} />
                        }
                    </div>}
                </div>
            </div>
        </Fragment>
    );
}

QueueTableSortHeader.propTypes = {
    sort: PropTypes.string,
    tableType: PropTypes.string,
    onSortChanged: PropTypes.func,
    isAssociateQueue: PropTypes.bool,
    associateFullName: PropTypes.string,
    queue: PropTypes.object,
    onChecked: PropTypes.func,
    toggleFilter: PropTypes.func
}

export default QueueTableSortHeader